






































import { bookModelProvider } from '../model'
import { defineClassComponent } from '@/hooks'
import { ImagePreview } from 'vant'
import { ref } from '@vue/composition-api'

export default defineClassComponent(
  () =>
    class {
      bookModel = bookModelProvider.inject()

      // 当前轮播项索引
      current = ref(0)

      // 轮播项改变时触发
      handleChange = (index: number) => {
        this.current.value = index
      }

      // 点击轮播项
      handleClick = (index: number) => {
        ImagePreview({
          images: this.bookModel.value.store.photoAlbum,
          startPosition: index,
        })
      }
    },
)
